import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  paypalId: string;
}

const updateUserPaymentAccount = async ({ paypalId }: Payload): Promise<any> => {
  const res = await axiosInstance.patch(`/api/payout/update-account-details`, { paypalId });
  return res.data;
};

export function useUpdateUserPaymentAccount() {
  return useMutation(updateUserPaymentAccount, { onSuccess: (data) => data });
}
